export default __webpack_public_path__ + "static/media/MCS-visual.4a46bd77.png";